import { usergroupUsersActions } from '../constants';

export const fetchUserGroupUsers = (category, code, page, pageSize) => ({
  type: usergroupUsersActions.FETCH_USERGROUP_USERS,
  category,
  code,
  page,
  pageSize,
});

export const showUserGroupUsers = (category, code, users) => ({
  type: usergroupUsersActions.SHOW_USERGROUP_USERS,
  category,
  code,
  users,
});

export const showUserGroupUsersError = (category, code, error) => ({
  type: usergroupUsersActions.SHOW_USERGROUP_USERS_ERROR,
  category,
  code,
  error,
});

export const updateUsergroupUsersToAdd = (category, code, users) => ({
  type: usergroupUsersActions.UPDATE_USERGROUP_USERS_TO_ADD,
  category,
  code,
  users,
});

export const addUsergroupUsers = (category, code) => ({
  type: usergroupUsersActions.ADD_USERGROUP_USERS,
  category,
  code,
});

export const addUsergroupUsersError = (category, code, group, errors) => ({
  type: usergroupUsersActions.ADD_USERGROUP_USERS_ERROR,
  category,
  code,
  errors,
  group,
});

export const addUsergroupUsersSuccess = (category, code, group, results) => ({
  type: usergroupUsersActions.ADD_USERGROUP_USERS_SUCCESS,
  category,
  code,
  group,
  results,
});

export const addUsergroupUsersLocal = (category, group, results) => ({
  type: usergroupUsersActions.ADD_USERGROUP_USERS_LOCAL,
  category,
  code: group.code,
  results,
});

export const removeUsergroupUser = (category, code, userId) => ({
  type: usergroupUsersActions.REMOVE_USERGROUP_USER,
  category,
  code,
  userId,
});

export const removeUsergroupUserError = (category, code, group, user, error) => ({
  type: usergroupUsersActions.REMOVE_USERGROUP_USER_ERROR,
  category,
  code,
  group,
  user,
  error,
});

export const removeUsergroupUserSuccess = (category, code, group, user) => ({
  type: usergroupUsersActions.REMOVE_USERGROUP_USER_SUCCESS,
  category,
  code,
  group,
  user,
});

export const removeUsergroupUserLocal = (category, group, user) => ({
  type: usergroupUsersActions.REMOVE_USERGROUP_USER_LOCAL,
  category,
  code: group.code,
  group,
  user,
});

export const dismissUsergroupUsersError = (category, code) => ({
  type: usergroupUsersActions.DISMISS_USERGROUP_USERS_ERROR,
  category,
  code,
});
